import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"]
})
export class FooterComponent implements OnInit {
  public phoneNumber: string;
  public email: string;

  constructor() {
    this.phoneNumber = '653 67 45 83';
    this.email = "oyoprofeJorge@gmail.com";
  }

  ngOnInit() {}
}
